

// Base64-encoded support/contact email addresses.
// NOTE: Base64 is obfuscation only (avoids plain-text addresses in source/bundle
// grep and basic scraping), not encryption. Only use this for low-risk, already
// public contact addresses — never for secrets or sensitive data.
const ENCODED_CONTACTS = {
  confidentiality: 'Y29uZmlkZW50aWFsaXR5QGFjY2VudHVyZS5jb20=',
  gccHealthCheckPoc: 'cGFydWwudi5qYWluQGFjY2VudHVyZS5jb20=',
};

/**
 * Decodes a registered contact key into its email address.
 * @param {keyof typeof ENCODED_CONTACTS} key
 * @returns {string} the decoded email address, or '' if the key is unknown
 */
function decodeContact(key) {
  const encoded = ENCODED_CONTACTS[key];
  if (!encoded) return '';
  try {
    return atob(encoded);
  } catch {
    return '';
  }
}

export const CONFIDENTIALITY_EMAIL = decodeContact('confidentiality');
export const GCC_HEALTH_CHECK_POC_EMAIL = decodeContact('gccHealthCheckPoc');
